<div class="wrapper" *ngIf="rowData">
  <label class="radio-label">
    <input type="checkbox"
           [value]="!!rowData.canChangeSupplierContract"
           [checked]="!!rowData.canChangeSupplierContract"
           (change)="setCanModifyContract()">
    Modificare/Schimbare contract
  </label>
  <label class="radio-label">
    <input type="checkbox"
           [value]="!!rowData.canEditInformation"
           [checked]="!!rowData.canEditInformation"
           (change)="setCanEditCompany()">
    Editare informatii firma
  </label>
  <label class="radio-label">
    <input type="checkbox"
           [value]="!!rowData.canViewInformation"
           [checked]="!!rowData.canViewInformation"
           (change)="setCanViewInformation()"
    >
    Vizualizare informatii
  </label>
</div>
